<template lang="pug">
  .lang-switcher
    ul.lang-switcher__list
      li.lang-switcher__item(
        v-for="language in languages"
        :key="language.id"
        :class="{ 'lang-switcher__item--active': language.key === lang }"
        @click="onLangChange(language.key)")
        span.lang-switcher__item-icon
          font-awesome-icon(
            size="sm"
            icon="check")
        .lang-switcher__item-text {{ language.label }}
</template>

<script>
import { LANG_VAR_LOCAL_STORAGE_KEY } from '@/util/consts'

export default {
  name: 'LangSwitcher',

  data: () => ({
    lang: localStorage.getItem(LANG_VAR_LOCAL_STORAGE_KEY) || 'uk',
    languages: [
      { id: 0, label: 'Українська', key: 'uk' },
      { id: 1, label: 'Русский', key: 'ru' },
      { id: 2, label: 'Polish', key: 'pl' },
      { id: 3, label: 'English', key: 'en' },
      { id: 4, label: 'Nederlands', key: 'nl' },
      { id: 5, label: 'Deutschland', key: 'de' },
      { id: 6, label: 'France', key: 'fr' },
      { id: 7, label: 'Italia', key: 'it' },
      { id: 8, label: 'România', key: 'ro' },
      { id: 9, label: 'USA', key: 'us' },
    ]
  }),

  methods: {
    onLangChange (lang) {
      this.lang = lang
      this.$i18n.set(lang)
      localStorage.setItem(LANG_VAR_LOCAL_STORAGE_KEY, lang)
      this.$store.dispatch('account/setLang', lang)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/sass/abstracts/_variables.scss';

  .lang-switcher {

    &__icon {
      width: 2.5rem;
      height: 2.5rem;
    }

    &__list {
      position: relative;
    }

    &__item {
      cursor: pointer;
      display: flex;
      margin-bottom: 1.3rem;
      padding-left: 3rem;
      transition: .3s ease;

      &:hover {
        color: $color-primary;
      }

      &:last-child {
        margin-bottom: 0;
      }

      &--active {
        .lang-switcher__item-icon {
          opacity: 1;
        }
        .lang-switcher__item-text {
          color: $color-primary;
        }
      }

      &-icon {
        opacity: 0;
        position: absolute;
        left: 0;
        font-size: 1.5rem;
        color: $color-primary;
      }

      &-text {
        font-size: 1.5rem;
        line-height: 1.8rem;
      }
    }
  }
</style>
